import {
    COMPLETE_TRIP_REQUEST,
    COMPLETE_TRIP_SUCCESS,
    COMPLETE_TRIP_FAILURE,
    GET_COMPLETE_BOOKING_BY_DATE_REQUEST,
    GET_COMPLETE_BOOKING_BY_DATE_SUCCESS,
    GET_COMPLETE_BOOKING_BY_DATE_FAILURE,
    RESET_COMPLETE_TRIP,
} from "../actions/completeAction";

const initialState = {
    completeTripLoading: false,
    completeTripSuccess: false,
    completeTripError: null as string | null,
    completeTripData: null as any,
    completeBookings: [],
    completeBookingsLoading: false,
    completeBookingsError: null,
    tablelength: 0,
    totalamount: 0,
    loading: false,
    success: false,
    error: null,
    message: null,
    data: null,
};

const completeReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case COMPLETE_TRIP_REQUEST:
            return {
                ...state,
                loading: true,
                success: false,
                error: null,
                message: null,
            };

        case COMPLETE_TRIP_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                error: null,
                message: action.payload.message,
                data: action.payload.data,
            };

        case COMPLETE_TRIP_FAILURE:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };

        case RESET_COMPLETE_TRIP:
            return {
                ...state,
                loading: false,
                success: false,
                error: null,
                message: null,
                data: null,
            };


        case GET_COMPLETE_BOOKING_BY_DATE_REQUEST:
            return { ...state, completeBookingsLoading: true, completeBookingsError: null };
        case GET_COMPLETE_BOOKING_BY_DATE_SUCCESS:
            return { ...state, completeBookingsLoading: false, completeBookings: action.payload.bookings, tablelength: action.payload.tablelength, totalamount: action.payload.totalamount };
        case GET_COMPLETE_BOOKING_BY_DATE_FAILURE:
            return { ...state, completeBookingsLoading: false, completeBookingsError: action.payload };
        default:
            return state;
    }
};

export default completeReducer;
